import React from 'react'
// Routing
import { Link } from 'react-router-dom'

// Styling
import styled from 'styled-components'

import { motion } from 'framer-motion'
import sn1 from '../images/SN/Image1.png'
import sn3 from '../images/SN/Image3.png'
import sn4 from '../images/SN/Image4.jpeg'
import sn5 from '../images/SN/Image5.jpeg'
import sn6 from '../images/SN/Image6.jpeg'

// Animations, Scroll and Icons
import { pageAnimation, Fade, imageAnimation, FadeLine } from './Animation'
import { ScrollToTop } from './ScrollToTop'
import { IoCaretBackCircleOutline } from 'react-icons/io5'
import { IconContext } from 'react-icons'

const ProjectInfoSN = () => {
    return (
        <ProjectContainer
            variants={pageAnimation}
            initial="hidden"
            animate="show"
        >
            <IconContext.Provider
                value={{
                    color: 'white',
                    size: '70px',
                    style: { marginLeft: '3rem' },
                }}
            >
                <Link to="/">
                    <Logo>
                        <motion.h2 variants={Fade}>Chirag Rao</motion.h2>
                        <motion.div variants={Fade}>
                            <IoCaretBackCircleOutline className="back" />
                        </motion.div>
                    </Logo>
                </Link>
            </IconContext.Provider>
            <div className="header">
                <motion.h1 variants={FadeLine}>Serenity Now</motion.h1>
                <motion.h3 variants={Fade}>
                    Buttery Smooth UX, Animations everywhere!
                </motion.h3>
            </div>
            <TopGallery>
                <Hide>
                    <motion.img
                        variants={imageAnimation}
                        src={sn6}
                        style={{ margin: '1rem 0rem' }}
                        alt="snimage1"
                    />
                </Hide>
                <Hide>
                    <motion.img
                        variants={imageAnimation}
                        src={sn1}
                        style={{
                            margin: '1rem 0rem',
                        }}
                        alt="snimage2"
                    />
                </Hide>
                <Hide>
                    <motion.img
                        variants={imageAnimation}
                        src={sn4}
                        style={{
                            margin: '1rem 0rem',
                        }}
                        alt="snimage3"
                    />
                </Hide>
            </TopGallery>
            <div className="content">
                <div className="top">
                    <div className="text">
                        <motion.h1 variants={FadeLine}>Introduction</motion.h1>
                        <motion.p variants={Fade}>
                            An React-Native app prototype to manage memorable
                            vacations and time off work with a beautiful UI and
                            Slick Animations. This app has a rich tech stack,
                            with technologies ranging from React Native, Redux
                            Toolkit, Firebase, GraphQL, AirBnb Lottie and much
                            more.
                        </motion.p>
                    </div>
                    <div className="imageflex">
                        <Hide>
                            <motion.img
                                variants={imageAnimation}
                                src={sn5}
                                alt=""
                            />
                        </Hide>
                        <div className="textinner">
                            <motion.h3 variants={Fade}>
                                What is the app about?
                            </motion.h3>
                            <motion.p variants={Fade}>
                                This app prototype is all about booking tours
                                and vacations. I didn't focus much on the
                                back-end, but spent a lot of time working on the
                                front-end, integrating various third party
                                API's, using a Content Management System like
                                Contentful and using its GraphQL API using
                                Apollo Client. This app is highly oriented
                                towards the user and has a rich tech-stack to
                                follow it up.
                            </motion.p>
                        </div>
                    </div>
                </div>
                <div className="imageflex1">
                    <Hide>
                        <motion.img
                            variants={imageAnimation}
                            src={sn3}
                            alt="icon"
                        />
                    </Hide>
                    <div className="textinner">
                        <motion.h3 variants={Fade}>App's features</motion.h3>
                        <motion.p variants={Fade}>
                            Gesture Control, Stackable cards, Modals, Persistent
                            Data Storage and Retrieval using Async Storage,
                            Complex State Management using Redux Toolkit,
                            Dynamic Data, Lottie Animations and a few other
                            awesome features.
                        </motion.p>
                    </div>
                </div>

                <Message style={{ marginTop: '5rem' }}>
                    <motion.small
                        style={{ fontSize: '1.5rem' }}
                        variants={Fade}
                    >
                        Links to the app apk and the repository
                        <br />
                        Use the email address -{' '}
                        <span style={{ color: '#23d997', fontWeight: 'bold' }}>
                            test@test.com
                        </span>{' '}
                        and password -{' '}
                        <span style={{ color: '#23d997', fontWeight: 'bold' }}>
                            test1234
                        </span>{' '}
                        to login and view the menu.
                        <br />
                        (I didn't implement a sign up functionality coz I was
                        lazy lol.)
                    </motion.small>
                </Message>
                <ButtonWrapper>
                    <motion.button variants={Fade}>
                        <a
                            style={{ textDecoration: 'none', color: 'white' }}
                            href="https://github.com/SpaceFace02/Serenity-Now"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            GitHub Repository
                        </a>
                    </motion.button>
                    <motion.button variants={Fade}>
                        <a
                            style={{ textDecoration: 'none', color: 'white' }}
                            href="https://drive.google.com/file/d/1AF1QB19_X8JogR81Rf_gc0tvgEf5ekYA/view?usp=sharing"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Download the APK
                        </a>
                    </motion.button>
                </ButtonWrapper>
            </div>
            <ScrollToTop />
        </ProjectContainer>
    )
}

const Logo = styled(motion.div)`
    position: absolute;
    top: 10px;
    left: 10px;
    font-family: 'Lobster';
    font-size: '1rem';
    float: right;
    display: flex;
    align-items: flex-end;
    padding: 0rem 1rem;
    margin: 2rem 0rem;
    .back {
        display: none;
    }
    @media screen and (max-width: 520px) {
        h2 {
            display: none;
        }
        .back {
            display: block;
        }
    }
`

export const Message = styled(motion.div)`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 7rem;
`

const TopGallery = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    img {
        width: 300px;
        height: 640px;
    }

    @media screen and (max-width: 520px) {
        flex-direction: column;
        div {
            img {
                height: 50%;
                width: 100%;
            }
        }
    }
`

const ProjectContainer = styled(motion.div)`
    max-width: 3000px;
    .header {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex-wrap: wrap;
        img {
            width: 100%;
            height: 30rem;
            object-fit: contain;
        }
    }
    .content {
        padding: 10px;
        .text {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 1rem 0rem;
            margin: 1rem 0rem 0rem 4rem;
            width: 90%;
        }
        p {
            margin: auto;
        }
    }

    font-family: 'Quicksand', sans-serif;
    .gallery {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h1 {
            width: 70%;
        }
        img {
            width: 1000px;
            margin: 1rem 0rem;
            padding: 1rem 0rem;
        }
        @media screen and (max-width: 520px) {
            img {
                width: 100%;
                height: 65vh;
                margin: 1rem 0rem;
                padding: 1rem 0rem;
            }
        }
    }
    .imageflex {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
        flex-direction: row;
        img {
            width: 1000px;
            height: 1000px;
            object-fit: contain;
            margin: 2rem 0rem 0rem 1rem;
        }
        .textinner {
            max-width: 800px;
        }
    }
    .imageflex1 {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
        flex-direction: row-reverse;
        img {
            width: 700px;
            height: 700px;
            object-fit: contain;

            margin: 2rem 0rem 0rem 1rem;
        }
        .textinner {
            max-width: 800px;
        }
    }

    h1 {
        color: white;
        font-weight: bolder;
        font-size: 3rem;
        padding: 1rem 0rem 2rem 0rem;
        text-align: center;
        font-size: 5rem;
        color: #23d997;
        border-bottom: 2px solid #23d997;
    }
    h3 {
        color: white;
        font-size: 2rem;
        font-weight: bolder;
        padding: 3rem 0rem 2rem 0rem;
        text-align: center;
    }
    p {
        margin: 4rem 0rem;
        color: white;
        font-size: 1.7rem;
        padding: 2rem 4rem;
        max-width: 1000px;
    }

    @media screen and (max-width: 520px) {
        img {
            width: 80%;
            height: 80vh;
            margin: 1rem 0rem;
            padding: 1rem 0rem;
        }
        p {
            font-size: 2rem;
        }
        h1 {
            font-size: 4rem;
        }
        h3 {
            font-size: 3.2rem;
        }
    }
`

const Hide = styled.div`
    overflow: hidden;
`

export default ProjectInfoSN
